import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=6b75bba8&"
import script from "./CreatePost.vue?vue&type=script&lang=js&"
export * from "./CreatePost.vue?vue&type=script&lang=js&"
import style0 from "./CreatePost.vue?vue&type=style&index=0&id=6b75bba8&prod&lang=css&"
import style1 from "./CreatePost.vue?vue&type=style&index=1&id=6b75bba8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports